import React, { useCallback } from 'react'
import Modal from 'components/Luxkit/Modal/Modal'
import OfferCalendarRoomOptions from './OfferCalendarRoomOptions'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

function OfferCalendarRoomModal() {
  const { resolve } = useModalElementContext()

  const onRoomSelect = useCallback(() => {
    resolve?.()
  }, [resolve])

  return (
    <Modal
      title="Rooms"
      primaryActionText="Apply"
    >
      <OfferCalendarRoomOptions onSelect={onRoomSelect} />
    </Modal>
  )
}

export default OfferCalendarRoomModal
